export const noopMiddleware = () => (next) => (action) => next(action);
//# sourceMappingURL=noop-middleware.js.map